import React, { useEffect, useState, useMemo, useCallback } from "react";
import InfoIcon from "@mui/icons-material/Info";
import CallStatisticsModal from "./CallStatisticsModal";

function CallInfo(props) {
  const { agentState, posts: propPosts, loading } = props;
  // State
  const [posts, setPosts] = useState([]);
  const [loginTime, setLoginTime] = useState("");
  const [readTime, setReadTime] = useState("");
  const [breakTime, setBreakTime] = useState("");
  const [callModal, setCallModal] = useState(false);

  // Increment function
  const incrementTime = useCallback((time) => {
    if (!time) return time;
    const [h, m, s] = time.split(":").map(Number);
    let totalSec = h * 3600 + m * 60 + s + 1;
    const newH = String(Math.floor(totalSec / 3600)).padStart(2, "0");
    const newM = String(Math.floor((totalSec % 3600) / 60)).padStart(2, "0");
    const newS = String(totalSec % 60).padStart(2, "0");
    return `${newH}:${newM}:${newS}`;
  }, []);

  // Initialize state from props
  useEffect(() => {
    if (!loading && Array.isArray(propPosts) && propPosts.length) {
      setPosts(propPosts);

      const getValue = (key) =>
        propPosts.find((item) => item.name === key)?.value || "";

      setLoginTime(getValue("Login Time"));
      setReadTime(getValue("Free Time"));
      setBreakTime(getValue("Break Time"));
    }
  }, [propPosts, loading]);

  // Interval for timers
  useEffect(() => {
    const interval = setInterval(() => {
      setLoginTime((prev) => incrementTime(prev));

      if (agentState === "FREE") {
        setReadTime((prev) => incrementTime(prev));
      } else if (agentState === "BREAK") {
        setBreakTime((prev) => incrementTime(prev));
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [agentState, incrementTime]);

  // Modal handlers
  const handlleOpen = useCallback(() => setCallModal(true), []);
  const handleClose = useCallback(() => setCallModal(false), []);

  // Memoized derived posts
  const displayPosts = useMemo(() => {
    return posts.map((post) => {
      let displayValue = post.value;
      if (post.name === "Login Time") displayValue = loginTime || post.value;
      else if (post.name === "Free Time") displayValue = readTime || post.value;
      else if (post.name === "Break Time") displayValue = breakTime || post.value;
      return { ...post, displayValue };
    });
  }, [posts, loginTime, readTime, breakTime]);

  return (
    <div>
      {callModal && (
        <CallStatisticsModal
          open={callModal}
          onClose={handleClose}
          date = {props.startDate}
        />
      )}

      {displayPosts.map((post) => (
        <div className="body" key={post.name}>
          <p className="name" style={{ color: "#686D88" }}>
            {post.name}
            {post.name === "Total Calls" && (
              <span
                title="Calls Analytics Summary"
                style={{ marginLeft: "6px", cursor: "pointer", fontSize: "14px" }}
              >
                <InfoIcon
                  onClick={handlleOpen}
                  sx={{ color: "#1976d2", fontSize: 16, marginLeft: "4px", verticalAlign: "middle" }}
                />
              </span>
            )}
          </p>
          <p className="value">
            <b>{post.displayValue}</b>
          </p>
        </div>
      ))}
    </div>
  );
}

export default React.memo(CallInfo)
